import { Injectable } from '@angular/core';
import { BaseAttachmentsService } from 'src/app/shared/attachments/base-attachments.service';

@Injectable()
export class FormTemplateAttachmentsFieldService extends BaseAttachmentsService {}
